// extracted by mini-css-extract-plugin
module.exports = {"paywallHeader":"choose-frequency-later-steps-content_paywallHeader__KbWPx"};